<template>
  <div :class="classInput">
    <div class="form-group">
      <label class="label" :class="{'required': isRequired}">{{ label }}</label>
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="'terms-' + id"
          :checked="isAccepted"
          disabled
        >
        <label class="custom-control-label" :for="'terms-' + id">
          <span :class="isAccepted ? 'text-success' : 'text-muted'">
            {{ isAccepted ? 'Aceito' : 'Não aceito' }}
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Boolean, String, Number],
      default: null
    },
    classInput: {
      type: String,
      default: 'col-sm-12'
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isAccepted () {
      if (this.value === true || this.value === 1) return true
      if (typeof this.value === 'string') {
        const normalized = this.value.toLowerCase().trim()
        return normalized === 'true' || normalized === '1' || normalized === 'sim'
      }
      return false
    }
  },
  methods: {
    // Sempre readonly — aceites são históricos e não devem ser editados pelo admin.
    // Expondo isValid/clean pra compatibilidade com o loop de validação do Form.vue.
    isValid () {
      return true
    },
    clean () {}
  }
}
</script>
